<!--- Reminder: If you are adding a new component, don't forget to register it in index.js --->

<template>
  <div class="checkbox field">
    <input type="checkbox"
           :checked="valueData"
           :value="valueData"
           :disabled="disabled"
           v-on:change="updateValue($event.target.checked)">
    <label class="inline-label" @click="onClick">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'ChcCheckbox',
  props: {
    value: {
      default: false
    },
    label: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (newValue) {
      this.valueData = newValue
    },
    valueData (newValue) {
      this.$emit('input', newValue)
    }
  },
  data () {
    return {
      valueData: this.value
    }
  },
  methods: {
    onClick () {
      this.valueData = !this.valueData
    },
    updateValue (newValue) {
      this.valueData = newValue
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables";

.checkbox {
  position: relative;
  // display: inline-block;
  input[type=checkbox] {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      height: 1.375rem;
      width: 1.375rem;
      z-index: 2;
      &:disabled {
        &:hover {
          cursor: not-allowed;
        }
        + label:hover {
          cursor: not-allowed;
        }
    }
    +label:before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        display: inline-block;
        height: 1.375rem;
        width: 1.375rem;
        border-radius: .25rem;
        background-color: $lt-grey;
    }
    &:checked+label:before {
        content: "\f00c";
        font-family: 'Font Awesome 5 Pro';
        font-weight: 400;
        color: $chc-purple;
      font-size: 1.125rem;
      text-align: center;
    }
    &:focus + label:before {
      outline-style: auto;
      outline-color: $blue;
    }
  }
  label {
      position: relative;
      display: inline-block;
      min-height: 1rem;
      padding-left: 1.75rem;
      cursor: pointer;
      line-height: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/ChcCheckbox.vue